import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SearchBox from "../CenterNavbar/SearchBox";
import "../Navbar.css";
import Sidebar from "./SideBarForMobileView";

const TopNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { currentUser } = useSelector((state) => state.User);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {isScrolled ? (
        <div
          className={`fixed text- left-0 right-0 w-full transition duration-700 ease-in-out bg-[#007bffdf]  z-50`}
        >
          {/* this is a sidebar only shown on small view  */}
          <Sidebar isOpen={isOpen} setIsOpen={setIsOpen} />
          <div className="max-w-7xl mx-auto py-3 px-2 flex items-center justify-between sm:px-6 lg:px-8 md:px-4  text-sm font-medium text-white hover:text-gray-100 capitalize font-workSans">
            {/* <p className="flex-1 text-sm text-center font-medium text-white sm:text-left lg:flex-none">
              Welcome to our store
            </p> */}
            <i
              onClick={() => setIsOpen((ope) => !ope)}
              className="text-2xl font-bold bi bi-list md:hidden"
            ></i>
            <div className="hidden md:block">
              <NavList />
            </div>
            <div className="flex items-center justify-center">
              <div>
                {/* SearchBar */}
                {isScrolled ? <SearchBar isScrolled={isScrolled} /> : null}
              </div>
              {!currentUser && (
                <ul className="md:flex items-center justify-center space-x-2 hidden md:space-x-6">
                  <li>Signup</li>
                  <li>Login</li>
                </ul>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={` fixed text- left-0 right-0 z-10 w-full transition duration-700 ease-in-out bg-[#007BFF] `}
        >
          <div className="max-w-7xl mx-auto py-2 px-4 flex items-center justify-start sm:px-6 lg:px-8 text-sm font-medium text-white hover:text-gray-100 capitalize font-workSans">
            {/* <p className="flex-1 text-sm text-center font-medium text-white sm:text-left lg:flex-none">
            Welcome to our store
          </p> */}
            <div>
              <NavList />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function NavList() {
  return (
    <ul className="flex items-start justify-start space-x-6">
      <li>Home</li>
      <li>about us</li>
      <li>contact us</li>
      <li>help</li>
    </ul>
  );
}
function SearchBar({ isScrolled }) {
  return (
    // <div className="flex border rounded bg-gray-300 items-center p-2 focus:ring-blue-500 z-40">
    //   <svg
    //     className="fill-current text-gray-800 mr-2 w-5"
    //     xmlns="http://www.w3.org/2000/svg"
    //     viewBox="0 0 24 24"
    //     width="24"
    //     height="24"
    //   >
    //     <path
    //       className="heroicon-ui"
    //       d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm9 11a1 1 0 0 1-2 0v-2a3 3 0 0 0-3-3H8a3 3 0 0 0-3 3v2a1 1 0 0 1-2 0v-2a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v2z"
    //     />
    //   </svg>
    //   <input
    //     type="text"
    //     placeholder="Enter Search here..."
    //     className="bg-gray-300 w-28 md:w-full max-w-full focus:outline-none text-gray-700 transition ease-in-out duration-500 focus:w-[500px] focus:z-40"
    //   />
    // </div>

    // isScrolled ? (
    <div
      className={` overflow-hidden transition duration-200 ease-in-out ${
        isScrolled && "vibrate"
      } `}
    >
      {" "}
      <SearchBox />
    </div>
    // ) : null
  );
}

export default TopNavbar;
